import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import IconButton from '@material-ui/core/IconButton'

const styles = (theme: CentricTheme) => ({
  root: {
    width:  theme.styles.components.button.height,  //todo - double check with Aaron
    height: theme.styles.components.button.height,
    color:  '#FFFFFF'
  }
})

export interface AppBarIconButtonProps extends StyledProps {
  disabled?: boolean
  onClick: (e) => void
  icon?: React.ReactNode
}

export class AppBarIconButtonComponent extends React.Component<AppBarIconButtonProps> {
  static defaultProps = {
    disabled: false,
    onClick:  () => {}
  }

  render() {
    const {classes, className, icon, onClick, disabled, ...otherProps} = this.props

    return (
      <IconButton
        className={classNames({root: classes.root}, className)}
        {...otherProps}
        disabled={disabled}
        onClick={onClick}>
        {icon}
      </IconButton>
    )
  }
}

@(withStyles as any)(styles)
export class AppBarIconButton extends AppBarIconButtonComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/AppBarIconButton.tsx